// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"328":"70e7a003","453":"72b1d83d","530":"2e9e46a4","810":"3905efb2"}[chunkId] + ".chunk.js";
};